import { EventEmitter } from '@angular/core';
import { FileClass } from './file.class';
import { FilesProvider, ImageReadyService } from './providers/';
var FileViewBase = /** @class */ (function () {
    function FileViewBase(fp, irs) {
        this.fp = fp;
        this.irs = irs;
        this._ready = false;
        this.readyChange = new EventEmitter();
    }
    Object.defineProperty(FileViewBase.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        set: function (value) {
            this._ready = value;
            this.readyChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    FileViewBase.prototype.onResize = function (event) {
        if (typeof (this.resized) === 'function') {
            this.resized(event);
        }
    };
    FileViewBase.prototype.loadFileBlob = function () {
        var _this = this;
        this.fp.getFile(this.file.id, this.file.mime, this.file.name).subscribe(function (url) {
            if (!url) {
                return false;
            }
            _this.fileLoaded(url);
        });
    };
    FileViewBase.prototype.fileLoaded = function (blob) {
    };
    FileViewBase.prototype.resized = function (event) { };
    return FileViewBase;
}());
export { FileViewBase };



// WEBPACK FOOTER //
// ./src/app/file.view.directive.ts.pre-build-optimizer.js